import {useNavigate} from "react-router-dom";
import {isNullOrUndefined} from "../../services/Validator";
import SystemNavigationItemIcon from "../icons/SystemNavigationItemIcon";
import SystemNavigationItemName from "../others/SystemNavigationItemName";
import {useRef, useState} from "react";
import SystemAppSideBarTooltip from "../tooltips/SystemAppSideBarTooltip";
import {kSystemDrawerNavText} from "../../constants/texts";

export default function SystemAppSideBarNavigationItem({item, isNarrowScreen, isCollapsed, isActive}) {
    // Used in SystemTopBarNavigation to display
    // side navigation items

    // PROPERTIES
    let navigate = useNavigate()
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const idleTimer = useRef(null);

    const handleMouseMove = (e) => {
        setShowTooltip(false);
        setTooltipPos({
            x: e.clientX,
            y: e.clientY,
        });
        clearTimeout(idleTimer.current);
        idleTimer.current = setTimeout(() => {
            setShowTooltip(true);
        }, 300); // délai "souris immobile"
    };
    const handleMouseLeave = () => {
        clearTimeout(idleTimer.current);
        setShowTooltip(false);
    };

    // BUILD
    if (isNullOrUndefined(item) || isNullOrUndefined(item.name) || isNullOrUndefined(item.route))
        return null
    return(
        <div className={`relative overflow-hidden group bg-transparent py-[16px] min-h-[56px] select-none
                        ${isActive ? `cursor-default border-l-[2px] ${item.name === kSystemDrawerNavText.brevet ? "border-greenStar" : "border-primary"}  text-white`
                                   : `cursor-pointer border-l border-transparent text-greyLight9 hover:text-white hover:border-l-[2px] ${item.name === kSystemDrawerNavText.brevet ? "hover:border-greenStar" : "hover:border-primary"}`}`}
             onClick={isActive ? null : () => navigate(item.route)}
             onMouseMove={handleMouseMove}
             onMouseLeave={handleMouseLeave}>
            <div className={`w-full flex items-center relative z-10 ${(isCollapsed || isNarrowScreen) ? "pr-[4px]" : "pl-[16px] pr-[10px]"} whitespace-nowrap`}>
                <div className={`w-full flex ${setFlexJustify()} items-center font-normal`}>
                    <SystemNavigationItemIcon icon={item.icon} />
                    {(!isCollapsed && !isNarrowScreen) && (
                        <SystemNavigationItemName name={item.name} />
                    )}
                </div>
            </div>
            <div className={`absolute inset-0 opacity-0 group-hover:opacity-30
                            bg-gradient-to-r ${item.name === kSystemDrawerNavText.brevet ? "from-[rgba(114,206,159,0.55)]" : "from-[rgba(48,174,247,0.55)]"} to-[rgba(255,255,255,0)]
                            ${isActive ? "opacity-30" : ""}`}>
            </div>
            {(showTooltip && (isCollapsed || isNarrowScreen)) && (
                <SystemAppSideBarTooltip showTooltip={showTooltip}
                                         tooltip={item.tooltip}
                                         tooltipPos={tooltipPos} />
            )}
        </div>
    );

    // METHODS
    // ---- UI : Set flex justify
    function setFlexJustify() {
        return (isNarrowScreen || isCollapsed) ? "justify-center" : "justify-start space-x-[12px]"
    }
}